import { supportedLanguages } from '@wb/shared/utils/supportedLanguages';

export default {
  name: 'overload',
  lookup() {
    const detectedLang = navigator.language.split('-')[0]; // Get base language

    // If language is 'nb' or 'nn', return 'no'
    if (['nb', 'nb-NO', 'nn', 'nn-NO'].includes(navigator.language)) {
      return 'no';
    }

    // If detected language isn't supported, fall back to English
    return supportedLanguages.includes(detectedLang) ? detectedLang : 'en';
  },
};
